export const handleSubmitForm = (values, mutateUpload) => {
  const uploadData = {
    telephone: values.telephone,
    fullName: values.fullName,
    mobileBrandId: values.mobileBrandId,
    mobileModelName: values.mobileModelName,
    channelBuyId: values.channelBuyId,
    productId: values.productId,
    invImage: values.invImage ? values.invImage[0] : null,
    packageImage: values.packageImage ? values.packageImage[0] : null,
    warrantyNumberCode: values.warrantyNumberCode,
    purchaseDate: values.purchaseDate || null,
  };

  mutateUpload(uploadData);
};
